import React from 'react';
import Logo from '../assets/images/GYM LOGO.png';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

const Footer = () => (
<div class="container">
<footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
    <div class="col-md-4 d-flex align-items-center">
      <a href="/" class="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1">
      <img src={Logo} alt='Logo' style={{ width: '40px' }} />
      </a>
      <span class="mb-3 mb-md-0 text-body-secondary ps-3">© 2023 MyGYM, Nishu Anand</span>
    </div>

    <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
      <li class="ms-3"><a class="text-body-secondary" href="#https://www.linkedin.com/in/nishu-anand-5961b0194/"><LinkedInIcon  style={{ 'font-size': '30px' }} /></a></li>
      <li class="ms-3"><a class="text-body-secondary" href="#https://github.com/NiSHUOP"><GitHubIcon style={{ 'font-size': '30px' }} /></a></li>
    </ul>
  </footer>
  </div>
 
);

export default Footer;